// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1L8gr","productName":"Table_productName__3Ivgi"};